import { useContext } from "react";
import { ActivitiesContext } from "../../context/activities-context";

const TransparentAgeFilter = () => {
	const { ageButtonId, setAgeButtonId, setAgeButtonActive, dictionaryWords } =
		useContext(ActivitiesContext);

	const changeAgeHandler = (event) => {
		setAgeButtonId(event.target.value);
		setAgeButtonActive(true);
	};

	return (
		<div className="c-transparent-filter__dropdown">
			<div className="c-input dropdown ">
				<label className="c-input__label">{dictionaryWords.forWhom}</label>
				<select 
					id="age_filter" 
					className="c-input__field c-toggle-label"
					onChange={changeAgeHandler}
					value={ageButtonId}
				>
					<option value="all">{dictionaryWords.allAges}</option>
					<option value="3-5">{dictionaryWords.threeFive}</option>
					<option value="6-8">{dictionaryWords.sixEight}</option>
					<option value="9-11">{dictionaryWords.nineEleven}</option>
					<option value="12-15">{dictionaryWords.twelveFifteen}</option>
					<option value="16-17">{dictionaryWords.sixteenSeventeen}</option>
					<option value="18+">{dictionaryWords.eighteenPlus}</option>
					<option value="55+">{dictionaryWords.fiftyFivePlus}</option>
				</select>
			</div>
		</div>
	);
};

export default TransparentAgeFilter;
